export class DateUtil {

    /**
     * now
     */
    public static now(): Date {
        return new Date(Date.now())
    }

    /**
     * 
     * @param a 
     * @param b 
     * @returns 
     */
    public static sort(a: Date, b: Date): number {
        return new Date(b).getTime() - new Date(a).getTime()        
    }

    /**
     * 
     * @param start 
     * @param end 
     * @returns 
     */
    public static diffSeconds(start: Date, end: Date): number {
        if (!start || !end)
            return 0;
        
        const dif = new Date(end).getTime() - new Date(start).getTime();
        const seconds = dif / 1000;
        return Math.abs(seconds);
    }

    /**
     *
     * @param dt
     * @param months
     * @returns
     */
    public static AddMonths(dt: Date, months: number): Date {
        return new Date(dt.setMonth(dt.getMonth() + months));
    }

    /**
     *
     * @param dt
     * @param seconds
     * @returns
     */
     public static AddSeconds(dt: Date, seconds: number): Date {
        return new Date(dt.setSeconds(dt.getSeconds() + seconds));
    }


    /**
     * parse it
     */
    public static Parse(v: string): Date {
        const n: number = Date.parse(v);
        return new Date(n);
    }

    /**
     *
     * @param dt
     * @returns mm/dd/yyyy hh:mm AM / PM
     */
    public static shortDateTime(dt: Date): string {
        const d = new Date(dt);

        const ret = `${d.toLocaleDateString()} ${d.toLocaleTimeString()}`;
        return ret;
    }

    /**
     *
     * @param dt
     * @returns
     */
    public static shortDate(dt: Date): string {
        return new Date(dt).toLocaleDateString();
    }

    public static readonly MinDate: string = '1971-01-01';
    public static readonly MaxDate: string = '2071-01-01';

    /**
     * 
     * @param value 
     * @returns 
     */
    public static isoDateString(value: Date): string {
        if (!value)
            return undefined;

        const ret = (new Date(value).toISOString()).split('T')[0];
        return ret;
    }

    /**
     * 
     * @param value 
     * @param min 
     * @param max 
     * @returns 
     */
    public static validateString(value: string, min: string = undefined, max: string = undefined): boolean {
        if (!value)
            return false;

        const dateValue = Date.parse(value);
        if (!dateValue)
            return false;

        const dateMin = Date.parse((min ?? DateUtil.MinDate)) ?? Date.parse(DateUtil.MinDate);
        const dateMax = Date.parse((min ?? DateUtil.MaxDate)) ?? Date.parse(DateUtil.MaxDate);
        
        const ret = dateValue >= dateMin && dateValue <= dateMax;
        return ret;
    }

}
